// @flow

import React from "react";
import * as colors from "src/styles/constants/colors";

const ServerError = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
    >
      <rect width="66" height="66" rx="33" fill="#F9FAFB" />
      <mask
        id="mask0_1082_72"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="66"
        height="66"
      >
        <rect width="66" height="66" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1082_72)">
        <path
          d="M33 57.75C31.4875 57.75 30.1927 57.2115 29.1156 56.1344C28.0385 55.0573 27.5 53.7625 27.5 52.25C27.5 50.7375 28.0385 49.4427 29.1156 48.3656C30.1927 47.2885 31.4875 46.75 33 46.75C34.5125 46.75 35.8073 47.2885 36.8844 48.3656C37.9615 49.4427 38.5 50.7375 38.5 52.25C38.5 53.7625 37.9615 55.0573 36.8844 56.1344C35.8073 57.2115 34.5125 57.75 33 57.75ZM27.5 41.25V8.25H38.5V41.25H27.5Z"
          fill="#98A2B3"
        />
      </g>
    </svg>
  );
};

export default ServerError;
